<template>
  <div
    class="orders-listing-page"
    :class="{ 'with-floating-buttons': showFloatingButtons }"
  >
    <call-center-orders-dashboard v-if="isCallCenter" />
    <filial-orders-page v-else />
    <collapsed-orders-bar />
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import CallCenterOrdersDashboard from '@/components/orders-list/CallCenterOrdersDashboard.vue'
  import FilialOrdersPage from '@/components/orders-list/FilialOrdersPage.vue'
  import CollapsedOrdersBar from '@/components/orders-list/CollapsedOrdersBar.vue'
  import { getSearchFromRoute } from '@/util/orders-route'

  export default {
    name: 'Orders',
    components: {
      FilialOrdersPage,
      CallCenterOrdersDashboard,
      CollapsedOrdersBar,
    },
    computed: {
      ...mapGetters({
        isCallCenter: 'branches/getGlobalFilialIsCallCenter',
      }),
      ...mapState({
        showFloatingButtons: (state) => state.app.showFloatingButtons,
      }),
    },
    watch: {
      '$route.query.search' () {
        this.syncSearchFromRoute()
      },
    },
    // created страницы отрабатывает раньше created дочерних списков:
    // при прямом заходе на /orders?search=... списки уже видят строку поиска.
    created () {
      this.syncSearchFromRoute()
    },
    methods: {
      syncSearchFromRoute () {
        this.$store.commit('orders/setOrdersSearchString', getSearchFromRoute(this.$route))
      },
    },
  }
</script>

<style lang="less" scoped>
.orders-listing-page {
  padding: 15px 0 15px 4px;

  &.with-floating-buttons {
    padding-bottom: 130px;
  }
}
</style>
